import React from 'react';
import Peca from './Peca';

// cartao Atendimento do Inicio: o mesmo da Central, vindo do pacote (ver pacote.js)
export default function CartaoAtendimento(){
    return <Peca peca="cartao" />;
}
